import { HttpService } from '../../../services/HttpService';
import * as Constants from './Constants';
import { apiUrls } from '../../../constants/apiUrl';
import {
  getPageName,
  getCookie,
  getAPPID,
  getFlowType,
  getSession,
  TechFlow,
  isPreorder,
  isMoversFlow,
  isSequentialFlow,
  isACPEligibile,
  isVFEligibile,
  isWHW,
  getSeqFlowType,
  isVfDiscountsFlow,
  isWHWP2,
  isExpressCheckout,
} from '../../../components/common/Helpers';
import { getSecureBaseUrl } from '../../../services/UrlMapperService';
import { store } from '../../../configureStore';

export const invokeTaggingAPI = (data) => ({
  type: Constants.INVOKE_TAGGING,
  data,
});
export const invokeTaggingflag = (data) => ({
  type: 'TAGGING_FLAG',
  data,
});
export const invokeTagging = (viewOverrides) => {
  const { throttleKey = [] } = viewOverrides || {};
  console.log(throttleKey);
  const pageNameVal = getPageName();
  const LQResponseData = JSON.parse(getSession('LQResponse'));

  let subFlowName = '';
  let subFlowName1 = '';
  const isLoggedIn = getAPPID() === 'AAL';
  let flowName = '';
  let throttleVal = '';
  const isVendor = getCookie('isvendorFLow');
  if (LQResponseData && LQResponseData !== undefined && LQResponseData.output) {
    if (LQResponseData?.output?.bundleDetails && LQResponseData?.output?.bundleDetails.length > 0) {
      subFlowName = 'mmwv';
      subFlowName1 = 'mmwv';
    }
    if (getSession('isCBandQual') === 'Y') {
      subFlowName = 'cband';
      subFlowName1 = 'cband';
    }
    if (getFlowType() === 'LTE') {
      subFlowName = 'lte';
      subFlowName1 = '4g_lte';
    }
    if (isACPEligibile()) {
      subFlowName += '|acp';
    }
    if (isVFEligibile()) {
      subFlowName += '|vfwd';
    }
    subFlowName = isVendor === 'true' ? `${subFlowName}_allconnect` : subFlowName;
    subFlowName1 = isVendor === 'true' ? `${subFlowName1}_allconnect` : subFlowName1;
    // eslint-disable-next-line no-unused-expressions
    isLoggedIn ? (flowName = `${subFlowName1}_aal`) : (flowName = `${subFlowName1}_nse`);
  }

  if (TechFlow() === 'true') {
    flowName = 'cband_aal';
    subFlowName = 'cband_techfail install_aal';
  }

  if (isVfDiscountsFlow() === true) {
    flowName = 'discounts';
    subFlowName = 'vfwd';
  }

  if (isPreorder() === true) {
    if (getSession('FlowType') === '5G' && getSession('isCBandQual') !== 'Y') {
      flowName = isLoggedIn ? '5g_preorder_aal' : '5g_preorder_nse';
    }
  }

  if (isMoversFlow()) {
    flowName = getSession('flowType') || '';
    subFlowName = getSession('subFlowType') || '';
  }

  if (isSequentialFlow() || getSeqFlowType() === 'EC_MOC_FWA' || getSeqFlowType() === 'EC_MAQ_FWA') {
    subFlowName = subFlowName ? `${subFlowName}|seq mh` : 'seq mh';
  }

  if (isWHW() || isWHWP2()) {
    subFlowName = subFlowName ? `${subFlowName} | redemption` : 'redemption';
    flowName = 'FWA offer redemption';
  }

  // const type = viewport();
  // throttleVal = type === 'mfapp' ? 'nsa version| 5G: mfapp' : 'nsa version';
  if (isExpressCheckout()) {
    throttleVal = 'nsa version|vhi|ec y';
  } else if (getSession('selfConv') === 'Y' && window?.location?.pathname?.includes('/sales/home/appointment.html')) {
    throttleVal = 'nsa version|vhi|self setup';
  } else {
    throttleVal = 'nsa version|vhi|ec n';
  }

  if (throttleKey?.length) {
    throttleVal = [throttleVal, ...throttleKey].join('|');
  }
  console.log(throttleVal);
  let requestBody;
  const { search } = window.location;
  const params = new URLSearchParams(search);
  if (window?.location?.pathname?.includes('/sales/home/retail/addresslookup.html')) {
    flowName = 'home';
  }
  if (
    (params.has('expresscart') && store.getState()?.expressCart?.updateCartFailResponse?.message) ||
    (params.has('expresscart') && store.getState()?.expressCart?.updateCartFail === true)
  ) {
    let text;
    let number = '404';
    if (store.getState()?.expressCart?.updateCartFailResponse?.message) {
      text = store.getState()?.expressCart?.updateCartFailResponse?.message;
      // eslint-disable-next-line no-useless-escape
      number = parseInt(text.replace(/[^0-9\.]/g, ''));
    }
    requestBody = {
      vzPage: {
        name: pageNameVal, // varies from page to page
        channel: '5G shop', // hardcoded
        throttle: throttleVal, // nsa version or nsa version| 5G: mfapp
        displayChannel: 'vzw', // hardcoded
        sourceChannel: 'vzw', // hardcoded
        flow: flowName, // this varies from UI - between aal,nse,gemini,luna etc
        subFlow: subFlowName, // this varies from UI - between gemini,luna etc
      },
      vzdl: {
        error: { Code: `${number}-${text}` },
      },
    };
  } else if (window.location.href.indexOf('plansOverview') > -1 && getSession('isPlansEdit') === 'Y') {
    requestBody = {
      vzPage: {
        name: pageNameVal, // varies from page to page
        channel: '5G shop', // hardcoded
        throttle: throttleVal, // nsa version or nsa version| 5G: mfapp
        displayChannel: 'vzw', // hardcoded
        sourceChannel: 'vzw', // hardcoded
        flow: flowName, // this varies from UI - between aal,nse,gemini,luna etc
        subFlow: subFlowName, // this varies from UI - between gemini,luna etc
        isPlansEdit: 'Y',
      },
    };
  } else if (window.location.href.indexOf('confirmation') > -1) {
    requestBody = {
      vzPage: {
        name: pageNameVal, // varies from page to page
        channel: '5G shop', // hardcoded
        throttle: throttleVal, // nsa version or nsa version| 5G: mfapp
        displayChannel: 'vzw', // hardcoded
        sourceChannel: 'vzw', // hardcoded
        flow: flowName, // this varies from UI - between aal,nse,gemini,luna etc
        subFlow: subFlowName, // this varies from UI - between gemini,luna etc
      },
      vzdl: {
        event: { value: 'purchase' },
      },
    };
  } else if (window.location.href.indexOf('broadBandFacts') > -1 || window.location.href.indexOf('addressSearch') > -1) {
    requestBody = {
      vzPage: {
        name: pageNameVal, // varies from page to page
        channel: 'learn', // hardcoded
        throttle: throttleVal, // nsa version or nsa version| 5G: mfapp
        displayChannel: 'vzw', // hardcoded
        sourceChannel: 'vzw', // hardcoded
        flow:
          getCookie('fcc') === true || getCookie('fcc') === 'true'
            ? 'broadband facts fwa'
            : getCookie('site') === 'NRFlow'
              ? 'broadband facts nr'
              : 'broadband facts',
        subFlow: subFlowName,
      },
      vzdl: {
        event: { value: 'purchase' },
      },
    };
  } else {
    requestBody = {
      vzPage: {
        name: pageNameVal, // varies from page to page
        channel: '5G shop', // hardcoded
        throttle: throttleVal, // nsa version or nsa version| 5G: mfapp
        displayChannel: 'vzw', // hardcoded
        sourceChannel: 'vzw', // hardcoded
        flow: flowName, // this varies from UI - between aal,nse,gemini,luna etc
        subFlow: subFlowName, // this varies from UI - between gemini,luna etc
      },
    };
  }

  if (window.location.href.indexOf('addons') > -1) {
    if (getSession('isPlansEdit') === 'Y') {
      requestBody.vzPage.repeatFlow = 'Y|CARTEDIT';
    } else if (getSession('addonBack') === 'true') {
      requestBody.vzPage.repeatFlow = 'Y|BROWSERBACK';
    } else if (getSession('isResumeOrder') === 'Y') {
      requestBody.vzPage.repeatFlow = 'Y|RESUMECART';
    }
  }

  return new Promise((resolve) => {
    const apiURL = `${getSecureBaseUrl()}${apiUrls().homePlansTaggingUrl}`;

    HttpService.post(apiURL, requestBody)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.log('Error in promise call', error);
      });
  });
};
